export const SEARCH_BRAND_REQUEST = 'SEARCH_BRAND_REQUEST';
export const SEARCH_BRAND_SUCCESS = 'SEARCH_BRAND_SUCCESS';
export const SEARCH_BRAND_FAILED = 'SEARCH_BRAND_FAILED';

export const SEARCH_BRAND_BY_URL_REQUEST = 'SEARCH_BRAND_BY_URL_REQUEST';
export const SEARCH_BRAND_BY_URL_SUCCESS = 'SEARCH_BRAND_BY_URL_SUCCESS';
export const SEARCH_BRAND_BY_URL_FAILED = 'SEARCH_BRAND_BY_URL_FAILED';

export const SEARCH_PRODUCT_REQUEST = 'SEARCH_PRODUCT_REQUEST';
export const SEARCH_PRODUCT_SUCCESS = 'SEARCH_PRODUCT_SUCCESS';
export const SEARCH_PRODUCT_FAILED = 'SEARCH_PRODUCT_FAILED';

export const SEARCH_PRODUCT_BY_URL_REQUEST = 'SEARCH_PRODUCT_BY_URL_REQUEST';
export const SEARCH_PRODUCT_BY_URL_SUCCESS = 'SEARCH_PRODUCT_BY_URL_SUCCESS';
export const SEARCH_PRODUCT_BY_URL_FAILED = 'SEARCH_PRODUCT_BY_URL_FAILED';

export const GET_PROMOTION_CODE_REQUEST = 'GET_PROMOTION_CODE_REQUEST';
export const GET_PROMOTION_CODE_SUCCESS = 'GET_PROMOTION_CODE_SUCCESS';
export const GET_PROMOTION_CODE_FAILED = 'GET_PROMOTION_CODE_FAILED';

export const CREATE_PROMOTION_CODE_REQUEST = 'CREATE_PROMOTION_CODE_REQUEST';
export const CREATE_PROMOTION_CODE_SUCCESS = 'CREATE_PROMOTION_CODE_SUCCESS';
export const CREATE_PROMOTION_CODE_FAILED = 'CREATE_PROMOTION_CODE_FAILED';

export const UPDATE_PROMOTION_CODE_REQUEST = 'UPDATE_PROMOTION_CODE_REQUEST';
export const UPDATE_PROMOTION_CODE_SUCCESS = 'UPDATE_PROMOTION_CODE_SUCCESS';
export const UPDATE_PROMOTION_CODE_FAILED = 'UPDATE_PROMOTION_CODE_FAILED';

export const SET_ACTIVE_PROMOTION_CODE = 'SET_ACTIVE_PROMOTION_CODE';
